import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    APIS,
    URLS,
    SF_UCR_RCPN_MGMT_INFO,
    SG_TRSF_HIST_LIST,
} from "@/tra/tancis/ptli/elctdoc/ucr/service/PtliUcrRcpnMgmtService";
import { comnUtils } from "@/comn/utils";

/*
 * UCR Transfer Modify
 * !== UCR 이관 수정 ==!
 */
export const PTLI0704002S = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();
    const { fullUcrNo } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "tinNo" }, { area: "postCd" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        ucrRcpnMgmtInfo: useForm({
            defaultSchema: SF_UCR_RCPN_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        trsfHistList: useGrid({
            defaultSchema: SG_TRSF_HIST_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Gets UCR Reception management information. !== UCR 수관 관리 정보를 조회한다.==!
        getUcrRcpnMgmtInfo: useFetch({
            api: () => {
                return APIS.getUcrRcpnMgmtInfo(fullUcrNo);
            },
            onSuccess: (data) => {
                form.ucrRcpnMgmtInfo.setValues(data.ucrRcpnMgmtInfo.content);
                grid.trsfHistList.setData(comnUtils.getGridData(data.trsfHistList.content));
            },
        }),

        // Update UCR Transfer Approval Status !== UCR 이관 승인 상태 수정==!
        updateUcrTrsfAprv: useFetch({
            api: (data) => APIS.updateUcrTrsfAprv(data),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.00003",
                });
                fetch.getUcrRcpnMgmtInfo.fetch();
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        //Approval UCR Transfer Info !==  UCR 이관 정보 승인==!
        updateUcrTrsfAprv: form.ucrRcpnMgmtInfo.handleSubmit(
            () => {
                const data = form.ucrRcpnMgmtInfo.getValues();
                modal.openModal({
                    content: "msg.ptl.00704",
                    onConfirm: () => {
                        fetch.updateUcrTrsfAprv.fetch(data);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getUcrRcpnMgmtInfo.fetch();
    }, []);

    const ucrtAprvDoneYn = form.ucrRcpnMgmtInfo.getValue("ucrtAprvDoneYn");

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={"UCR"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrNo} readOnly={true}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            {/* <Group>
                <Group.Body>
                    <Group.Title title={t("T_TRSF_APRV_STAT")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAprvDoneYn}></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAprvDoneDtm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtApvr}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group> */}

            <Group>
                <Group.Body>
                    <Group.Title title={t("T_TRSFR_APLC")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAplcNm}></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAplcCntyCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.ucrRcpnMgmtInfo.schema.ucrtAplcTin}
                                callback={(data) => {
                                    form.ucrRcpnMgmtInfo.setValue("ucrtAplcAddr", data.rowData.coAddr);
                                    form.ucrRcpnMgmtInfo.setValue("ucrtAplcTelno", data.rowData.rprsTelno);
                                    form.ucrRcpnMgmtInfo.setValue("ucrtAplcFaxNo", data.rowData.rprsFaxNo);
                                }}
                            ></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAplcAddr}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAplcTelno}></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtAplcFaxNo}></Group.Control>
                        </Group.Row>
                        <Group.Cell root>
                            <Group.Cell header>L_TRSFRR_APLC_POST_ADDR</Group.Cell>
                            <Group.Cell size={10}>
                                <Group.Cell size={10} gap={2}>
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtAplcPostCd} />
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtAplcPostBaseAddr} />
                                </Group.Cell>
                                <Group.Cell size={10}>
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtAplcPostDtlAddr} />
                                </Group.Cell>
                            </Group.Cell>
                        </Group.Cell>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={t("T_TRSF_RECPT")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtRecptNm}></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtRecptCntyCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.ucrRcpnMgmtInfo.schema.ucrtRecptTin}
                                callback={(data) => {
                                    form.ucrRcpnMgmtInfo.setValue("ucrtRecptAddr", data.rowData.coAddr);
                                    form.ucrRcpnMgmtInfo.setValue("ucrtRecptTelno", data.rowData.rprsTelno);
                                    form.ucrRcpnMgmtInfo.setValue("ucrtRecptFaxNo", data.rowData.rprsFaxNo);
                                }}
                            ></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtRecptAddr}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtRecptTelno}></Group.Control>
                            <Group.Control {...form.ucrRcpnMgmtInfo.schema.ucrtRecptFaxNo}></Group.Control>
                        </Group.Row>
                        <Group.Cell root>
                            <Group.Cell header>L_TRSFR_RECPT_POST_ADDR</Group.Cell>
                            <Group.Cell size={10}>
                                <Group.Cell size={10} gap={2}>
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtRecptPostCd} />
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtRecptPostBaseAddr} />
                                </Group.Cell>
                                <Group.Cell size={10}>
                                    <FormControl {...form.ucrRcpnMgmtInfo.schema.ucrtRecptPostDtlAddr} />
                                </Group.Cell>
                            </Group.Cell>
                        </Group.Cell>
                    </Group.Section>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Group.Title title={t("T_TRSF_APRV_HIST")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Grid {...grid.trsfHistList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0704001q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right hidden={ucrtAprvDoneYn === "Y"}>
                    <Button
                        onClick={() => {
                            handler.updateUcrTrsfAprv();
                        }}
                    >
                        {t("B_TRSF_APRV", { 0: "Label" })}
                    </Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
